exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-menu {\n    height: 0;\n    overflow: hidden;\n        transition: height 0.4s ease-out;\n    -ms-transition: height 0.4s ease-out;\n    -moz-transition: height 0.4s ease-out;\n    -webkit-transition: height 0.4s ease-out;\n}\n\n.nav-menu.wrapped {\n    height: 100%;\n    box-shadow: 0px 1px 5px 2px #e2d9d9;\n}\n\n.nav-menu.wrapped .ui.list {\n    padding-bottom: 0.5em;\n}\n\n.nav-menu .item {\n    padding-top: 1em;\n    padding-left: 4em;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/nav/nav.component.css
// module id = 859
// module chunks = 0